// AdminDashboard.js
import React, { useState, useEffect } from "react";
import "./AdminDashboard.css";
import { useAuth } from "../context/AuthContext";

// Import section components
import CollegeManagement from "./CollegeManagement";
import Departments from "./Departments";
import Courses from "./Courses";
import UsersManagement from "./UsersManagement";
import Timetable from "./Timetable";
// 🔥 Use Overview instead of Analytics
import Overview from "./Overview";

function AdminDashboard() {
  const [activeSection, setActiveSection] = useState("college");

  // ✅ Auth Context
  const { adminUser, logoutAdmin } = useAuth();

  // === Shared states across sections (with persistence) ===
  const [collegeSelected, setCollegeSelected] = useState(
    JSON.parse(localStorage.getItem("collegeSelected")) || false
  );
  const [departmentAdded, setDepartmentAdded] = useState(
    JSON.parse(localStorage.getItem("departmentAdded")) || false
  );
  const [usersGenerated, setUsersGenerated] = useState(
    JSON.parse(localStorage.getItem("usersGenerated")) || false
  );
  const [timetableCreated, setTimetableCreated] = useState(
    JSON.parse(localStorage.getItem("timetableCreated")) || false
  );

  const [departments, setDepartments] = useState(
    JSON.parse(localStorage.getItem("departments")) || []
  );
  const [facultyList, setFacultyList] = useState(
    JSON.parse(localStorage.getItem("facultyList")) || []
  );
  const [studentList, setStudentList] = useState(
    JSON.parse(localStorage.getItem("studentList")) || []
  );

  // === Save updates to localStorage whenever state changes ===
  useEffect(() => {
    localStorage.setItem("collegeSelected", JSON.stringify(collegeSelected));
  }, [collegeSelected]);

  useEffect(() => {
    localStorage.setItem("departmentAdded", JSON.stringify(departmentAdded));
  }, [departmentAdded]);

  useEffect(() => {
    localStorage.setItem("usersGenerated", JSON.stringify(usersGenerated));
  }, [usersGenerated]);

  useEffect(() => {
    localStorage.setItem("timetableCreated", JSON.stringify(timetableCreated));
  }, [timetableCreated]);

  useEffect(() => {
    localStorage.setItem("departments", JSON.stringify(departments));
  }, [departments]);

  useEffect(() => {
    localStorage.setItem("facultyList", JSON.stringify(facultyList));
  }, [facultyList]);

  useEffect(() => {
    localStorage.setItem("studentList", JSON.stringify(studentList));
  }, [studentList]);

  // === Render section dynamically ===
  const renderSection = () => {
    switch (activeSection) {
      case "college":
        return (
          <CollegeManagement
            setCollegeSelected={setCollegeSelected}
            setDepartments={setDepartments}
          />
        );
      case "departments":
        return (
          <Departments
            departments={departments}
            setDepartments={setDepartments}
            setDepartmentAdded={setDepartmentAdded}
          />
        );
      case "courses":
        return (
          <Courses departments={departments} setDepartments={setDepartments} />
        );
      case "users":
        return (
          <UsersManagement
            departments={departments}
            facultyList={facultyList}
            studentList={studentList}
            setFacultyList={setFacultyList}
            setStudentList={setStudentList}
            setUsersGenerated={setUsersGenerated}
          />
        );
      case "timetable":
        return (
          <Timetable
            departments={departments}
            setTimetableCreated={setTimetableCreated}
          />
        );
      case "analytics":
        return (
          <Overview
            departments={departments}
            facultyList={facultyList}
            studentList={studentList}
          />
        );
      default:
        return <h2>Welcome to Admin Dashboard</h2>;
    }
  };

  // ✅ If no admin is logged in, block access
  if (!adminUser) {
    return <h2>❌ Unauthorized. Please login as Admin.</h2>;
  }

  return (
    <div className="admin-dashboard">
      <aside className="sidebar">
        <h2>Admin Dashboard</h2>
        <ul>
          <li onClick={() => setActiveSection("college")}>Welcome</li>
          <li onClick={() => setActiveSection("departments")}>Departments</li>
          <li onClick={() => setActiveSection("courses")}>Courses</li>
          <li onClick={() => setActiveSection("users")}>Users</li>
          <li onClick={() => setActiveSection("timetable")}>Timetable</li>
          <li onClick={() => setActiveSection("analytics")}>Analytics</li>
        </ul>

        {/* ✅ Logout button */}
        <button
          onClick={logoutAdmin}
          style={{
            marginTop: "20px",
            padding: "8px 12px",
            background: "red",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </aside>

      <main className="content">{renderSection()}</main>
    </div>
  );
}

export default AdminDashboard;
